export default "__VITE_ASSET__CdNBv80j__"